(() => {
  const init = () => {
    const form = document.querySelector('input[data-name-initials-field]')?.form;
    if (!form) return;
    const fields = [...document.querySelectorAll('.custom-option')].filter(row => row.querySelector('input[form="' + form.getAttribute('id') + '"]'));
    fields.forEach(row => form.prepend(row));
    const inputs = fields.map(row => row.querySelector('input'));
    const validate = () => {
      inputs.forEach(input => {input.value = input.value.trim();});
      const invalid = inputs.find(input => !input.checkValidity());
      if (!invalid) return true;
      invalid.scrollIntoView({behavior:'smooth',block:'center'});
      invalid.reportValidity();
      return false;
    };
    window.addEventListener('click', event => {
      const trigger = event.target.closest('[name="add"], [data-sticky-add], [data-sticky-buy], .shiprocket-headless');
      if (!trigger) return;
      if (trigger.closest('form') !== form && !trigger.closest('desitech-sticky-cart') && !trigger.closest('.section-main-product')) return;
      if (!validate()) {event.preventDefault();event.stopImmediatePropagation();}
    }, true);
    window.addEventListener('submit', event => {
      if (event.target === form && !validate()) {event.preventDefault();event.stopImmediatePropagation();}
    }, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();